// 统一管理后端接口地址和上传地址
// 优先使用环境变量，方便区分测试/生产环境
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || "https://api.sw.tianxinghuayi.cn/";

// 统一的上传地址
export const UPLOAD_URL = API_BASE_URL + "file/upload";

export default {
  API_BASE_URL,
  UPLOAD_URL,
};
